import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonLayoutComponent } from './layouts/common-layout/common-layout.component';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';
import { SharedModule } from './shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ContactusComponent } from './modules/contactus/contactus.component';
import { AuthService } from './shared/services/auth.service';
import { NgHttpLoaderModule } from "ng-http-loader";
import { ToastrModule } from "ngx-toastr";
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AuthInterceptor } from './authentication/auth.interceptor';
import { NoSidenavLayoutComponent } from './layouts/no-sidenav-layout/no-sidenav-layout.component';
import { NoSidenaveNoHeaderLayoutComponent } from './layouts/no-sidenave-no-header-layout/no-sidenave-no-header-layout.component';
import { OrganizationDashComponent } from './modules/dashboard/organization-dash/organization-dash.component';
import { TeamDashComponent } from './modules/dashboard/team-dash/team-dash.component';
import { RestaurantDashComponent } from './modules/dashboard/restaurant-dash/restaurant-dash.component';
import { ModalModule } from "ngx-bootstrap/modal";
import { BankingDetailsComponent } from './modules/banking-details/banking-details.component';
import { PaymentDetailsComponent } from './modules/payment-details/payment-details.component';
import { PlayerServicesService } from './shared/services/players-services.service';
import { RestaurantService } from './shared/services/restaurant-services.';
import { MatTimepickerModule } from 'mat-timepicker';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

// ./add-event-popup/add-event-popup.component
@NgModule({
  declarations: [
    AppComponent,
    CommonLayoutComponent,
    FullLayoutComponent,
    ContactusComponent,
    NoSidenavLayoutComponent,
    NoSidenaveNoHeaderLayoutComponent,
    OrganizationDashComponent,
    TeamDashComponent,
    RestaurantDashComponent,
    BankingDetailsComponent,
    PaymentDetailsComponent,
  ],
  imports: [
    MatSidenavModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatButtonModule,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CommonModule,
    NgHttpLoaderModule.forRoot(),
    ModalModule.forRoot(),
    ToastrModule.forRoot({
      preventDuplicates: true,
    }),
    NgHttpLoaderModule.forRoot(),
    MatTimepickerModule,
    MatCheckboxModule,
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),

  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],

  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    AuthService, PlayerServicesService, RestaurantService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
